export const Constants = {
  TAG_NAME: 'pop-pc-performance-table-component',
  TRANSLATION_KEYS: {
    HEADERS: {
      TABLE_NAME: 'tables.performance.headers.table_name',
      YTD: 'tables.performance.headers.ytd',
      ONE_YEAR: 'tables.performance.headers.one_year',
      THREE_YEARS: 'tables.performance.headers.three_years',
      FIVE_YEARS: 'tables.performance.headers.five_years',
      TEN_YEARS: 'tables.performance.headers.ten_years',
      SINCE_INCEPTION: 'tables.performance.headers.since_inception',
      INCEPTION_DATE: 'tables.performance.headers.inception_date',
      MORNINGSTAR: 'tables.performance.headers.morningstar',
      MORNINGSTAR_MEDALIST: 'tables.performance.headers.morningstar_medalist',
      MORNINGSTAR_RATING: 'tables.performance.headers.morningstar_rating',
      FUND_SIZE: 'tables.performance.headers.fund_size',
    },
  },
  PERFORMANCE_COLUMN_IDS: {
    PERFORMANCE_TABLE: 'performance-table',
    YTD: 'yearToDate',
    ONE_YEAR: 'oneYear',
    THREE_YEARS: 'threeYears',
    FIVE_YEARS: 'fiveYears',
    TEN_YEARS: 'tenYears',
    SINCE_INCEPTION: 'sinceInception',
    INCEPTION_DATE: 'inceptionDate',
    MORNINGSTAR_MEDALIST: 'morningstarMedalistRating',
    MORNINGSTAR_RATING: 'morningstarRating',
    FUND_SIZE: 'fundSize',
  },
  TABLE_ELEMENT_TYPE: {
    PRODUCT: 'product',
    PERFORMANCE: 'performance',
    RATING: 'rating',
    BUTTON: 'button',
  },
  BEACON_TAGS: {
    BEACON_ICON_BUTTON: 'beacon-icon-button',
  },
  RATING_ROW_CLASS: 'b-flex b-justify-center',
} as const;
